export const getCacheIndexes = state => state.cacheIndexes;
export const getEnterprises = state => state.enterprises.data;
export const getSites = state => state.sites;
